<div class="dialog-shell">
	<div class="dialog-header">
		<div>
			<h2 class="fw-bold fs-xs" *ngIf="dialogTitle">{{ dialogTitle }}</h2>
			<p class="fs-xxs gray" *ngIf="dialogDescription">
				{{ dialogDescription }}
			</p>
		</div>
		<button mat-icon-button type="button" (click)="onClose()">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<div
		class="active-missing-layout"
		*ngIf="isComparisonSummaryLayout; else defaultInlineHeader"
	>
		<section class="duplicate-case-summary" *ngIf="isDuplicateInFile">
			<span class="label">Divergência</span>
			<strong>Beneficiário duplicado</strong>
			<p class="fs-xxxs gray">{{ duplicateDivergenceSummary }}</p>
		</section>

		<section
			class="organization-mismatch-summary"
			*ngIf="isOrganizationMismatch"
		>
			<div class="organization-transfer-route">
				<div class="organization-transfer-card">
					<span class="label">Atual na plataforma</span>
					<strong>{{ currentOrganizationLabel }}</strong>
				</div>
				<mat-icon>east</mat-icon>
				<div
					class="organization-transfer-card organization-transfer-card--target"
				>
					<span class="label">Esperada pela base</span>
					<strong>{{ expectedOrganizationLabel }}</strong>
				</div>
			</div>
		</section>

		<div
			class="summary-banner"
			*ngIf="
				!isDuplicateInFile &&
				!isOrganizationMismatch &&
				!isActiveMissingCreateCase &&
				!isInactiveMissingInFile
			"
		>
			<div>
				<span class="label">Resumo do caso</span>
				<strong>{{ categoryLabel }}</strong>
				<p class="fs-xxxs gray">{{ categoryDescription }}</p>
			</div>
			<div class="summary-banner__statuses">
				<div class="status-summary-chip status-summary-chip--spreadsheet">
					<span class="label">Base do cliente</span>
					<strong>{{ summarySpreadsheetStatusLabel }}</strong>
				</div>
				<div class="status-summary-chip status-summary-chip--system">
					<span class="label">Plataforma</span>
					<strong>{{ summarySystemStatusLabel }}</strong>
				</div>
			</div>
		</div>

		<section class="creation-status-route" *ngIf="isActiveMissingCreateCase">
			<div class="creation-status-card">
				<span class="label">Base do cliente</span>
				<strong>{{ summarySpreadsheetStatusLabel }}</strong>
			</div>
			<mat-icon>east</mat-icon>
			<div class="creation-status-card creation-status-card--target">
				<span class="label">Plataforma</span>
				<strong>{{ summarySystemStatusLabel }}</strong>
			</div>
		</section>

		<section class="creation-status-route" *ngIf="isInactiveMissingInFile">
			<div class="creation-status-card creation-status-card--missing">
				<span class="label">Base do cliente</span>
				<strong>{{ summarySpreadsheetStatusLabel }}</strong>
			</div>
			<mat-icon>east</mat-icon>
			<div class="creation-status-card">
				<span class="label">Plataforma</span>
				<strong>{{ summarySystemStatusLabel }}</strong>
			</div>
		</section>

		<section class="comparison-section" *ngIf="isDuplicateInFile">
			<div class="comparison-section__header">
				<h3 class="fs-xxs fw-bold">Beneficiário analisado</h3>
			</div>
			<div class="info-grid">
				<div class="info-card">
					<span class="label">Nome</span>
					<strong>{{ duplicateSubjectName }}</strong>
				</div>
				<div class="info-card">
					<span class="label">CPF</span>
					<strong>{{ duplicateSubjectCpf || '-' }}</strong>
				</div>
			</div>
		</section>

		<div
			class="comparison-sections"
			[class.comparison-sections--active-missing]="isActiveMissingInDatabase"
			*ngIf="!isDuplicateInFile && !isOrganizationMismatch"
		>
			<section
				class="comparison-section creation-data-section"
				*ngIf="isActiveMissingCreateCase"
			>
				<div class="comparison-section__header">
					<h3 class="fs-xxs fw-bold">Dados recebidos da base do cliente</h3>
				</div>
				<p class="fs-xxxs gray">
					Campos usados para criar automaticamente e dados complementares
					relevantes.
				</p>
				<div class="creation-data-grid">
					<div
						class="creation-data-field"
						[class.creation-data-field--missing]="field.isMissing"
						*ngFor="let field of creationDataFields"
					>
						<span class="label">{{ field.label }}</span>
						<strong>{{ field.value }}</strong>
					</div>
				</div>
				<div
					class="creation-blocking-message"
					*ngIf="missingEssentialFieldsForDisplay.length > 0"
				>
					<strong>
						Este beneficiário não pode ser criado automaticamente.
					</strong>
					<span>
						Faltou dado essencial:
						{{ missingEssentialFieldsSentence }}.
					</span>
				</div>
				<div
					class="missing-fields-summary"
					*ngIf="creationComplementaryMissingFieldsForDisplay.length > 0"
				>
					<span>Dados faltantes:</span>
					<ul>
						<li
							*ngFor="let field of creationComplementaryMissingFieldsForDisplay"
						>
							{{ field }}
						</li>
					</ul>
				</div>
			</section>
			<section
				class="comparison-section"
				[class.comparison-section--organization]="isOrganizationMismatch"
				*ngIf="!isActiveMissingCreateCase && !isInactiveMissingInFile"
			>
				<div class="comparison-section__header">
					<h3 class="fs-xxs fw-bold">
						{{
							isActiveMissingReactivationCase
								? 'Dados da base do cliente (novos dados)'
								: 'Dados da base do cliente'
						}}
					</h3>
					<span
						class="status-chip"
						[class.inactive]="shouldHighlightSpreadsheetSummary"
					>
						{{ summarySpreadsheetStatusLabel }}
					</span>
				</div>
				<p class="fs-xxxs gray">{{ spreadsheetSectionDescription }}</p>
				<div class="info-grid" *ngIf="isActiveMissingInDatabase">
					<div class="info-card" *ngFor="let field of spreadsheetAllFields">
						<span class="label">{{ field.label }}</span>
						<strong>{{ field.value || '-' }}</strong>
					</div>
				</div>
				<div
					class="info-grid"
					*ngIf="
						!isActiveMissingInDatabase &&
							!isInactiveMissingInFile &&
							!isOrganizationMismatch;
						else spreadsheetSpecialBlock
					"
				>
					<div class="info-card">
						<span class="label">CPF</span>
						<strong>{{ data.item.beneficiaryCpf }}</strong>
					</div>
					<div class="info-card">
						<span class="label">Nome</span>
						<strong>
							{{ getDisplayValue(externalSnapshot, 'beneficiaryName') }}
						</strong>
					</div>
					<div class="info-card">
						<span class="label">Operadora</span>
						<strong>{{ externalCarrierLabel }}</strong>
					</div>
					<div class="info-card">
						<span class="label">Plano</span>
						<strong>{{ getDisplayValue(externalSnapshot, 'planName') }}</strong>
					</div>
					<div class="info-card">
						<span class="label">Carteirinha</span>
						<strong>
							{{ getDisplayValue(externalSnapshot, 'cardNumber') }}
						</strong>
					</div>
					<div class="info-card">
						<span class="label">Titularidade</span>
						<strong>
							{{
								getDisplayValue(externalSnapshot, 'titularity', 'parentesco')
							}}
						</strong>
					</div>
				</div>
				<ng-template #spreadsheetSpecialBlock>
					<div class="empty-candidates" *ngIf="isInactiveMissingInFile">
						Beneficiário não encontrado na base do cliente.
					</div>
					<div class="info-grid" *ngIf="isOrganizationMismatch">
						<div class="info-card">
							<span class="label">Unidade esperada</span>
							<strong>{{ expectedOrganizationLabel }}</strong>
						</div>
					</div>
				</ng-template>
			</section>

			<section
				class="comparison-section comparison-section--system"
				[class.comparison-section--organization]="isOrganizationMismatch"
				*ngIf="shouldShowActiveMissingSystemDetails"
			>
				<div class="comparison-section__header">
					<h3 class="fs-xxs fw-bold">
						{{
							isInactiveMissingInFile
								? 'Beneficiário na plataforma'
								: isActiveMissingReactivationCase
									? 'Dados atuais na plataforma'
									: 'Dados na plataforma'
						}}
					</h3>
					<span
						*ngIf="!isInactiveMissingInFile"
						class="status-chip"
						[class.inactive]="shouldHighlightSystemSummary"
					>
						{{ summarySystemStatusLabel }}
					</span>
				</div>
				<p class="fs-xxxs gray">{{ systemSectionDescription }}</p>

				<div
					class="info-grid"
					*ngIf="isInactiveMissingInFile; else defaultSystemDetails"
				>
					<div class="info-card" *ngFor="let field of inactivePlatformFields">
						<span class="label">{{ field.label }}</span>
						<strong>{{ field.value }}</strong>
					</div>
				</div>

				<ng-template #defaultSystemDetails>
					<div
						class="info-grid"
						*ngIf="
							currentSystemValue || isOrganizationMismatch;
							else systemNotFound
						"
					>
						<div class="info-card">
							<span class="label">Status</span>
							<strong>{{ systemRecordStatusLabel }}</strong>
						</div>
						<div class="info-card" *ngIf="!isOrganizationMismatch">
							<span class="label">Plano</span>
							<strong>
								{{ getDisplayValue(currentSystemValue, 'planName') }}
							</strong>
						</div>
						<div class="info-card" *ngIf="!isOrganizationMismatch">
							<span class="label">Carteirinha</span>
							<strong>
								{{ getDisplayValue(currentSystemValue, 'cardNumber') }}
							</strong>
						</div>
						<div class="info-card" *ngIf="!isOrganizationMismatch">
							<span class="label">Organização atual</span>
							<strong>
								{{ getDisplayValue(currentSystemValue, 'organizationName') }}
							</strong>
						</div>
						<div class="info-card" *ngIf="isOrganizationMismatch">
							<span class="label">Unidade atual</span>
							<strong>{{ getSystemOrganizationLabel() }}</strong>
						</div>
					</div>
				</ng-template>

				<ng-template #systemNotFound>
					<div
						class="empty-candidates empty-candidates--info"
						*ngIf="
							isActiveMissingInDatabase && candidateMatches.length > 0;
							else systemMissingBlock
						"
					>
						Não há cadastro ativo para este CPF, mas existe cadastro na
						plataforma para reaproveitamento.
					</div>
					<ng-template #systemMissingBlock>
						<div class="empty-candidates">
							Beneficiário não encontrado na plataforma.
						</div>
					</ng-template>
				</ng-template>
			</section>
		</div>
	</div>

	<ng-template #defaultInlineHeader>
		<div class="info-grid">
			<div class="info-card info-card--wide">
				<span class="label">Categoria</span>
				<strong>{{ categoryLabel }}</strong>
				<p class="fs-xxxs gray">{{ categoryDescription }}</p>
			</div>
			<div class="info-card">
				<span class="label">CPF</span>
				<strong>{{ data.item.beneficiaryCpf }}</strong>
			</div>
			<div class="info-card">
				<span class="label">Operadora</span>
				<strong>{{ data.item.carrier || '-' }}</strong>
			</div>
		</div>
	</ng-template>

	<div
		class="missing-fields-alert missing-fields-alert--essential"
		*ngIf="
			missingEssentialFieldsForDisplay.length > 0 && !isActiveMissingCreateCase
		"
	>
		<p class="missing-fields-alert__title">Dados essenciais faltantes:</p>
		<ul class="missing-fields-alert__list">
			<li *ngFor="let field of missingEssentialFieldsForDisplay">
				{{ field }}
			</li>
		</ul>
	</div>

	<div
		class="missing-fields-alert"
		*ngIf="
			missingImportantFieldsForDisplay.length > 0 && !isActiveMissingCreateCase
		"
	>
		<p class="missing-fields-alert__title">Dados faltantes:</p>
		<ul class="missing-fields-alert__list">
			<li *ngFor="let field of missingImportantFieldsForDisplay">
				{{ field }}
			</li>
		</ul>
	</div>

	<div
		class="transfer-route"
		*ngIf="action === 'TRANSFER_ORGANIZATION' && !isOrganizationMismatch"
	>
		<div class="transfer-card">
			<span class="label">Sai de</span>
			<strong>{{ currentOrganizationLabel }}</strong>
		</div>
		<mat-icon>east</mat-icon>
		<div class="transfer-card">
			<span class="label">Vai para</span>
			<strong>{{ expectedOrganizationLabel }}</strong>
		</div>
	</div>

	<div class="note-box" *ngIf="resolutionNote">
		<mat-icon>info</mat-icon>
		<span>{{ resolutionNote }}</span>
	</div>

	<form [formGroup]="form" class="dialog-form">
		<div
			class="comparison-section duplicate-list"
			*ngIf="isDuplicateInFile"
			#duplicateLayoutCapture
		>
			<div class="comparison-section__header">
				<div>
					<h3 class="fs-xxs fw-bold">Linhas duplicadas encontradas</h3>
					<p class="fs-xxxs gray">
						Compare os registros abaixo e selecione qual linha da base do
						cliente deve ser mantida.
					</p>
				</div>
			</div>

			<div class="empty-candidates" *ngIf="duplicateRows.length === 0">
				Nenhuma linha duplicada detalhada foi enviada pelo backend para este
				item.
			</div>

			<div class="duplicate-grid" *ngIf="duplicateRows.length > 0">
				<button
					type="button"
					class="duplicate-card"
					*ngFor="let row of duplicateRows; let index = index"
					[class.active]="
						form.get('selectedDuplicateRowIndex')?.value === index
					"
					[attr.aria-pressed]="
						form.get('selectedDuplicateRowIndex')?.value === index
					"
					(click)="selectDuplicateRow(index)"
				>
					<div class="duplicate-card__top">
						<div>
							<span class="duplicate-card__eyebrow">
								Linha {{ row.rowNumber || index + 1 }}
							</span>
							<p class="duplicate-card__name">
								{{ row.beneficiaryName || duplicateSubjectName }}
							</p>
							<p class="duplicate-card__meta">
								{{
									formatCpf(row.beneficiaryCpf) || duplicateSubjectCpf || '-'
								}}
							</p>
						</div>
						<span
							class="duplicate-card__selector"
							[class.active]="
								form.get('selectedDuplicateRowIndex')?.value === index
							"
						></span>
					</div>

					<div class="duplicate-card__body">
						<div class="duplicate-detail-grid">
							<div
								class="duplicate-detail"
								[class.duplicate-detail--different]="detail.isDifferent"
								*ngFor="let detail of getDuplicateRowCompactDetails(row)"
							>
								<span>{{ detail.label }}</span>
								<strong [attr.title]="detail.value">{{ detail.value }}</strong>
							</div>
						</div>
						<p
							class="duplicate-card__line duplicate-card__line--source"
							*ngIf="row.sourceFileName || row.sheetName"
						>
							{{ getDuplicateRowSource(row) }}
						</p>
					</div>

					<div class="duplicate-card__footer">
						<span class="duplicate-card__select-label">Usar esta linha</span>
					</div>
				</button>
			</div>
		</div>

		<div
			class="action-section"
			[class.action-section--highlight]="isComparisonSummaryLayout"
			*ngIf="!isDuplicateInFile && visibleActionOptions.length > 0"
		>
			<div class="comparison-section__header">
				<span class="review-badge" *ngIf="suggestedAction">
					Sugestao da plataforma: {{ suggestedActionDescription }}
				</span>
			</div>

			<div
				class="action-radio-group"
				*ngIf="shouldShowActionChoices; else suggestedActionSummary"
			>
				<button
					type="button"
					class="action-radio-option"
					[class.active]="action === option.value"
					*ngFor="let option of visibleActionOptions"
					(click)="onSelectAction(option.value)"
				>
					<input
						type="radio"
						[checked]="action === option.value"
						(change)="onSelectAction(option.value)"
					/>
					<div class="action-radio-option__content">
						<strong>{{ option.label }}</strong>
						<span>{{ option.description }}</span>
					</div>
				</button>
			</div>
			<ng-template #suggestedActionSummary>
				<div
					class="action-radio-option action-radio-option--summary active"
					*ngIf="primaryVisibleActionOption as option"
				>
					<div class="action-radio-option__content">
						<strong>{{ option.label }}</strong>
						<span>{{ option.description }}</span>
					</div>
				</div>
			</ng-template>
		</div>

		<div
			class="candidate-list"
			*ngIf="
				isActiveMissingInDatabase &&
				action === 'REACTIVATE_BENEFICIARY' &&
				candidateMatches.length > 0
			"
		>
			<h4 class="fs-xxxs fw-bold">
				Cadastros existentes na plataforma
				<span class="gray" *ngIf="hasInactiveCandidate">
					(status anterior: inativo)
				</span>
			</h4>
			<button
				type="button"
				class="candidate-card"
				*ngFor="
					let candidate of candidateMatches;
					let index = index;
					trackBy: trackByCandidate
				"
				[class.active]="form.get('selectedCandidateIndex')?.value === index"
				(click)="selectCandidate(candidate, index)"
			>
				<div class="candidate-card__header">
					<div>
						<strong>
							{{ candidate.beneficiaryName || candidate.beneficiaryCpf }}
						</strong>
						<p class="fs-xxxs gray">
							{{ getCandidateMeta(candidate).join(' - ') || '-' }}
						</p>
						<p class="fs-xxxs gray">
							{{ getCandidateHint(candidate) }}
						</p>
					</div>
					<span
						class="duplicate-card__selector"
						[class.active]="form.get('selectedCandidateIndex')?.value === index"
					></span>
				</div>
				<div class="candidate-card__details">
					<div
						class="candidate-card__detail"
						*ngFor="let detail of getCandidateDetails(candidate)"
					>
						<span class="label">{{ detail.label }}</span>
						<strong>{{ detail.value }}</strong>
					</div>
				</div>
				<div class="candidate-meta">
					<span
						class="status-chip"
						[class.inactive]="!candidate.active || candidate.isDeleted"
					>
						{{ candidate.active && !candidate.isDeleted ? 'Ativo' : 'Inativo' }}
					</span>
					<span class="fs-xxxs gray">{{ candidate.typeKinship }}</span>
				</div>
			</button>
		</div>

		<div
			class="candidate-list"
			*ngIf="shouldShowCandidateSection && !isActiveMissingInDatabase"
		>
			<h3 class="fs-xxs fw-bold">
				Cadastros ja encontrados na plataforma para este CPF
			</h3>
			<p class="fs-xxxs gray">
				Esses registros ja existem na plataforma e podem ser reaproveitados em
				vez de criar um novo cadastro.
			</p>
			<div class="empty-candidates" *ngIf="candidateMatches.length === 0">
				Nenhum cadastro prévio encontrado na plataforma para esta ação.
			</div>

			<button
				type="button"
				class="candidate-card"
				*ngFor="let candidate of candidateMatches; trackBy: trackByCandidate"
				[class.active]="
					form.get('selectedBeneficiaryId')?.value === candidate.beneficiaryId
				"
				(click)="selectCandidate(candidate)"
			>
				<div>
					<strong>
						{{ candidate.beneficiaryName || candidate.beneficiaryCpf }}
					</strong>
					<p class="fs-xxxs gray">
						{{ candidate.organizationName || '-' }} -
						{{ candidate.planName || 'Sem plano' }}
					</p>
				</div>
				<div class="candidate-meta">
					<span
						class="status-chip"
						[class.inactive]="!candidate.active || candidate.isDeleted"
					>
						{{ candidate.active && !candidate.isDeleted ? 'Ativo' : 'Inativo' }}
					</span>
					<span class="fs-xxxs gray">{{ candidate.typeKinship }}</span>
				</div>
			</button>
		</div>

		<div class="form-grid" *ngIf="shouldShowName">
			<mat-form-field appearance="outline">
				<mat-label>Nome do beneficiário</mat-label>
				<input matInput formControlName="name" type="text" />
			</mat-form-field>

			<mat-form-field appearance="outline">
				<mat-label>E-mail</mat-label>
				<input matInput formControlName="email" type="email" />
			</mat-form-field>
		</div>

		<div class="form-grid" *ngIf="shouldShowBirthDay">
			<mat-form-field appearance="outline">
				<mat-label>Data de nascimento</mat-label>
				<input matInput formControlName="birthDay" type="date" />
			</mat-form-field>
		</div>

		<div class="form-grid" *ngIf="shouldShowTitularityFields">
			<mat-form-field appearance="outline">
				<mat-label>Titularidade / parentesco</mat-label>
				<mat-select formControlName="typeKinship">
					<mat-option
						*ngFor="let option of kinshipOptions"
						[value]="option.value"
					>
						{{ option.label }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="outline" *ngIf="shouldShowHolderCpf">
				<mat-label>CPF do titular</mat-label>
				<input matInput formControlName="holderCpf" type="text" />
			</mat-form-field>
		</div>

		<p class="error-message" *ngIf="errorMessage">{{ errorMessage }}</p>
	</form>

	<div class="dialog-actions">
		<div class="dialog-actions__secondary">
			<button mat-stroked-button type="button" (click)="onIgnore()">
				Ignorar
			</button>
			<button
				mat-stroked-button
				color="primary"
				type="button"
				[disabled]="!canSave || action === 'IGNORE_ITEM'"
				(click)="onApplyOnly()"
			>
				Aplicar somente este
			</button>
		</div>
		<div class="dialog-actions__primary">
			<button
				mat-flat-button
				color="primary"
				type="button"
				[disabled]="!canSave || action === 'IGNORE_ITEM'"
				(click)="onSave()"
			>
				Salvar na fila
			</button>
			<button
				mat-button
				color="warn"
				type="button"
				[disabled]="!hasPendingChange"
				(click)="onRemove()"
			>
				Remover da fila
			</button>
		</div>
	</div>
</div>
